<template>
  <div v-if="componentReady" class="createmastercourses">
    <div class="content">

      <Disclaimer v-if="(info.status === 'PUBLISHED') && !isCopyRoute" />

      <!-- PASO 1 -->

      <div class="info" >
        <h1 style="text-align: center" v-html="$t('configurationMasterCourses.MAKE_COPY_OF_MASTER_COURSE')"></h1>
        <h3>{{ $t('configurationMasterCourses.STEP_NUMBER', { number: 1 }) }}</h3>
        <h5>{{ $t('configurationMasterCourses.GENERAL_CONFIGURATION') }}</h5>
        <Input 
          :label="$t('configurationMasterCourses.INTERNAL_NAME')"
          id="short_name"
          :supportText="$t('configurationMasterCourses.INTERNAL_NAME_SUPPORT_TEXT')"
          v-model="info.internalName"
          :isError="v$.info.internalName.required.$invalid && submitted"
          :errorMessage="$t('configurationMasterCourses.FIELD_REQUIRED')"
        />

        <!-- <Input 
          type="number"
          id="id"
          label="ID del curso"
          :disabled="true"
        /> -->


        <!-- <Select 
          mode="simple"
          :values="[1,2,3,4]"
          label="Categoría"
          id="category"
          v-model="info.category"
          :isError="v$.info.category.required.$invalid && submitted"
          errorMessage="Este campo es requerido"
        />

        <Select 
          mode="simple"
          :values="['Docentes', 'Jovenes']"
          label="Público"
          id="public"
          v-model="info.public"
          :isError="v$.info.public.required.$invalid && submitted"
          errorMessage="Este campo es requerido"
        /> -->
        <div class="info__cover">
          <span style="font-size: 12px; font-weight: 700;">{{ $t('configurationMasterCourses.COURSE_COVER') }}</span>

          <div 
            v-if="!info.file" 
            :class="`step1__uploadFile${v$.info.file.required.$invalid && submitted ? '--required' : ''}`"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
          >
            <i class="material-icons-outlined">cloud_upload</i>
            <label for="uploadFile">
              <span>{{ $t('configurationMasterCourses.UPLOAD_A_FILE') }}</span>
              <input type="file" accept="image/png" name="uploadFile" id="uploadFile" @change="addFile($event)"  >
            </label>
            <span>{{ $t('configurationMasterCourses.FILE_DIMENSIONS_HINT') }}</span>
          </div>

          <template v-if="info.file">
            <span style="font-size: 12px; font-weight: 700;">{{ $t('configurationMasterCourses.UPLOADED_FILES') }}</span>
            
            <div class="step1__fileUploaded">
              <div clasS="step1__fileUploaded_data">
                <i class="material-icons-outlined">image</i>
                <span class="step1__fileUploaded_file">
                  <a v-if="typeof info.file == 'string'" :href="info.file" target="_blank" style="cursor: pointer;">{{ $t('configurationMasterCourses.ONE_FILE_UPLOADED') }}</a>
                  <template v-else>
                    <span>{{info.fileName}}</span>
                    {{ info.fileSize }} KB
                  </template>
                </span>
              </div>
              <i @click="deleteFile" class="material-icons-outlined">close</i>
            </div>

          </template>
        </div>


        <Input 
          :label="$t('configurationMasterCourses.SHORT_NAME')"
          id="complete_name"
          :supportText="$t('configurationMasterCourses.SHORT_NAME_SUPPORT_TEXT')"
          v-model="info.name"
          :isError="v$.info.name.required.$invalid && submitted"
          :errorMessage="$t('configurationMasterCourses.FIELD_REQUIRED')"
        />



          <Select
            mode="simple" 
            id="modality" 
            :label="$t('configurationMasterCourses.COURSE_TYPE')"
            :values="formattedCourseTypes"
            valueLabel="name"
            valueProp="id" 
            v-model="info.courseType" 
            :isError="v$.info.courseType.required.$invalid && submitted"
            :errorMessage="$t('configurationMasterCourses.FIELD_REQUIRED')"
            :disabled="(info.status === 'PUBLISHED') && !isCopyRoute"
          />


          <Select
            mode="simple" 
            id="targetType" 
            :label="$t('configurationMasterCourses.TARGET_TYPE')"
            :values="formattedTargetTypes"
            valueLabel="name"
            valueProp="id" 
            v-model="info.targetType" 
            :isError="v$.info.targetType.required.$invalid && submitted"
            :errorMessage="$t('configurationMasterCourses.FIELD_REQUIRED')"
            :disabled="(info.status === 'PUBLISHED') && !isCopyRoute"
          />






      </div>



      <Modal :isOpen="exitWithoutSaveModal" @close="exitWithoutSaveModal = false">
        <div class="exitWithoutSaveModal">
          <h2 class="exitWithoutSaveModal__title">{{ $t('configurationMasterCourses.EXIT_EDITING_TITLE') }}</h2>
          <span class="exitWithoutSaveModal__content">{{ $t('configurationMasterCourses.EXIT_EDITING_CONTENT') }}</span>
          <div class="exitWithoutSaveModal__buttons">
            <button class="exitWithoutSaveModal__cancel" @click="exitWithoutSaveModal = false">{{ $t('global.CANCEL') }}</button>
            <button class="exitWithoutSaveModal__exit" @click="router.push('/contents/mastercourses')">{{ $t('configurationMasterCourses.EXIT_EDITING_BUTTON') }}</button>
          </div>
        </div>
      </Modal>

      <div class="buttons">
        <button @click="cancel()" class="button__backward"><i class="material-icons-outlined">arrow_back</i> {{ $t('global.BACK') }}</button>
        <button :disabled="submitting" @click="submitStep" class="button__forward">{{ $t('global.CONTINUE') }}<i class="material-icons-outlined">arrow_forward</i></button>
      </div>
    </div>

  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Inputs/Select.vue';
import { useRoute, useRouter } from 'vue-router';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import storage from "@/plugins/azure-storage";
import { useStore } from 'vuex';
import Modal from '../../../components/Modal.vue';
import Disclaimer from '../MastersCourses/Disclaimer.vue';
import { useI18n } from 'vue-i18n';


export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    creationOptions: {
      type: Object,
      required: true
    }
  },
  components: {
    Input,
    Select,
    Modal,
    Disclaimer
},
  setup(props, { emit }) {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const v$ = useVuelidate()
    const submitted = ref(false)
    const isDraggin = ref(false)
    const componentReady = ref(false)
    // const creationOptions = ref()
    const submitting = ref(false)
    const exitWithoutSaveModal = ref(false)


    const { t } = useI18n()




    const formattedCourseTypes = computed(() => {
      return props.creationOptions.courseTypes.map(type => ({
        id: type.id,
        name: t(`course.courseTypes.${type.name}`)
      }));
    });
    const formattedTargetTypes = computed(() => {
      return props.creationOptions.targetType.map(type => ({
        id: type.id,
        name: t(`course.targetTypes.${type.name}`)
      }));
    });


    // Computed property to check if the URL ends with 'copy'
    const isCopyRoute = computed(() => {
      return route.path.endsWith('/copy');
    });

    const info1_invalid = computed(() => 
      v$.value.info.internalName.required.$invalid || 
      v$.value.info.name.required.$invalid || 
      v$.value.info.file.required.$invalid || 
      v$.value.info.courseType.required.$invalid ||
      v$.value.info.targetType.required.$invalid
    );

    const info = ref()
    
    const dragover = (e) => {
      e.preventDefault();
      isDraggin.value = true
    }

    const dragleave = (e) => {
      e.preventDefault();
      isDraggin.value = false
    }

    const drop = (e) => {
      e.preventDefault()
      info.value.fileName = e.dataTransfer.files[0].name
      info.value.fileSize = Math.round(e.dataTransfer.files[0].size / 1024)
      info.value.file = e.target.files[0]
      isDraggin.value = false
    }

    const deleteFile = () => {
      info.value.file = ''
      info.value.fileName = ''
      info.value.fileSize = ''
    }


    const addFile = e => {
      info.value.fileName = e.target.files[0].name
      info.value.fileSize = Math.round(e.target.files[0].size / 1024)
      info.value.file = e.target.files[0]
    }

    const cancel = () => {
      exitWithoutSaveModal.value = true
    }

    function createThumbnail(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();

        reader.onload = function (event) {
          var img = new Image();
          img.src = event.target.result;

          img.onload = function () {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var maxWidth = 320;
            var maxHeight = 180;

            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
              }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            var thumbnailBase64 = canvas.toDataURL('image/png');
            var thumbnailBlob = dataURItoBlob(thumbnailBase64);
            var thumbnailFileName = file.name.replace('.png', '_thumbnail.png');
            var thumbnailFile = new File([thumbnailBlob], thumbnailFileName, { type: 'image/png' });

            resolve(thumbnailFile);
          };
        };

        reader.onerror = function (error) {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    }

    function dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    }


    const submitStep = async () => {
      if(submitting.value) return
      submitted.value = true
      if (info1_invalid.value) return
      try {
        submitting.value = true
        if (typeof info.value.file !== 'string') {
          let thumbnail = await createThumbnail(info.value.file)
            .then(thumbnail => {
              console.log(thumbnail)
              return thumbnail; // Aquí puedes acceder al objeto File de la miniatura
            })
            .catch(error => {
              console.error('Error al crear la miniatura:', error);
            });
          let fileCDN = await storage.updateFile(info.value.file, 'content')
          let fileThumbnail = await storage.updateFile(thumbnail, 'content', `${fileCDN.split('.').slice(0, -1).join('.')}_thumb`);
          console.log(fileThumbnail)
          // info.value.file = `https://lmsforgestorage.blob.core.windows.net/contentresources/${fileCDN}`
          let blobPath = process.env.VUE_APP_CDN_URL
          if (process.env.VUE_APP_STORAGE_MODE == 'ps-storage') {
            blobPath = process.env.VUE_APP_PSSTORAGE_URL
          }

          // Asignar la ruta final al archivo del curso
          info.value.file = `${blobPath}contentresources/${fileCDN}`
          }
        if (route.path.toLowerCase().includes('copy')) {
          const { data } = await store.dispatch('courses_cfgclone', info.value)
          emit('changeData', data)
          router.push(`/contents/mastercourses/${data.courseCfgId}/information`)
        }
        else {
          await store.dispatch('courses_cfgfirstStep', info.value)
          router.push(`information`)
        }
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('configurationMasterCourses.ERROR_CONTINUING') })
      } finally {
        submitting.value = false
      }
    }

    onMounted(() => {
      info.value = props.data
      componentReady.value = true
    })

    return {
      router,
      info,
      v$,
      submitted,
      isDraggin,
      componentReady,
      // creationOptions,
      submitting,
      exitWithoutSaveModal,
      isCopyRoute,
      formattedCourseTypes,
      formattedTargetTypes,

      addFile,
      dragover,
      dragleave,
      drop,
      submitStep,
      deleteFile,
      cancel
    } 
  },
  validations() {
    return {
      info: {
        internalName: { required },
        name: { required },
        // category: { required },
        // public: { required },
        file: { required },
        courseType: { required },
        targetType: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.buttons{
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  .button{
      text-align: center;
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 12px;
      border-radius: 999px;
      padding: 12px 18px;
      &__forward{
        @extend .button;
        color: #fff;
        background-color: $green;
      }
      &__backward{
        @extend .button;
        border: 1px solid $green;
        color: $green;
        background-color: inherit;
      }
      &:disabled{
        cursor: default;
        opacity: .6;
      }
  }
}

.exitWithoutSaveModal{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  padding: 24px;
  &__title{
    font-weight: 600;
    font-size: 18px;
  }
  &__content{
    font-size: 18px;
    font-weight: 400;
  }
  &__buttons{
    display: flex;
    align-items: center;
    gap: 16px;
  }
  &__cancel{
    border: none;
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }
  &__exit{
    padding: 12px 0;
    width: 182px;
    background-color: #F57055;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    border-radius: 44px;
  }
}

.goBack{
  color: $green;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  .material-icons-outlined{
    font-size: 18px;
  }
}

.content{
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  padding: 32px 0;
}

.info{
  display: flex;
  flex-direction: column;
  max-width: 370px;
  width: 100%;
  margin: 0 auto;
  gap: 18px;
  align-items: center;
  h1{
    font-size: 24px;
    font-weight: 800;
  }
  h3{
    font-size: 14px;
    font-weight: 800;
  }
  h5{
    font-size: 20px;
    font-weight: 600;
  }
}
.info__cover {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
  span{
    font-size: 12px;
    font-weight: 700;
  }
}
.step{
  &1__uploadFile{
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f6f6f6;
    align-items: center;
    padding: 27px 0;
    border-radius: 10px;
    font-size: 12px;
    &--required{
      @extend .step1__uploadFile;
      border: 1px solid #F57055;
    }
    .material-icons-outlined{
      padding: 12px;
      border-radius: 99px;
      color: #fff;
      background-color: $green;
      margin-bottom: 12px;
    }
    label{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $green;
      cursor: pointer;
      font-weight: 600;
      margin-bottom: 12px;
      input{
        display: none;
      }
    }
  }

  &1__fileUploaded{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 26px 28px;
    background-color: #F6F6F6;
    width: 100%;
    &_data{
      display: flex;
      align-items: center;
      gap: 12px;
      .material-icons-outlined:first-child{
        font-size: 28px;
      }
    }
    &_file{
      display: flex;
      flex-direction: column;
      gap: 6px;
      font-size: 16px;
      font-weight: 400;
      a, span{
        //cursor: pointer;
        text-decoration: none;
        font-size: 16px;
        font-weight: 600;
        color: $green;
      }
    }
    .material-icons-outlined:last-child{
      cursor: pointer;
    }
  }
}
.header-steps{
    width: 100%;
    margin-bottom: 32px;
    height: 86px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 42px;
    border-bottom: 1px solid #D9D9D9;
    background: #fff;
    .step{
        @include icon-and-text-container;
        span:first-child{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            border-radius: 100%;
            background: #BDBDBD;
            color: #fff;
            font-size: 11px;
            font-weight: 700;
            line-height: 28px;
        }
        span:last-child{
            font-size: 13px;
            font-weight: 600;
            color: #BDBDBD;
        }
        &--selected{
            span:first-child{
                background: #FFB23F;
                color: #212121;
            }
            span:last-child{
                color: #212121;
            }
        }
        .material-icons{
            color: #77C991;
            font-size: 29px
        }
        @media screen and (max-width: 800px){
            display: none;
            &.step--selected{
                display: flex;
            }
        }
    }
}

</style>
